export default __webpack_public_path__ + "static/media/1365.ee46177d.png";